exports = module.exports = require("../../node_modules/_css-loader@0.27.3@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".peoplex[data-v-163498ce]{background:#fff;border-radius:2px;padding:15px 10px}.fade-enter-active[data-v-163498ce],.fade-leave-active[data-v-163498ce]{transition:all .4s ease}.fade-enter[data-v-163498ce],.fade-leave-active[data-v-163498ce]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.27.3@css-loader?minimize!./~/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-163498ce","scoped":true,"hasInlineConfig":false}!./~/_sass-loader@7.1.0@sass-loader/lib/loader.js!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/components/peoplex.vue
// module id = 165
// module chunks = 1